import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from '../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';

@Component({
    selector: 'kiene-finanzen',
    templateUrl: './finanzen.component.html',
    styleUrls: ['./finanzen.component.scss'],
})
export class FinanzenComponent implements OnInit {
    constructor(
        private localStorageService: LocalStorageService,
        private router: Router,
    ) {
        this.localStorageService.setCurrentClientVisible(true);
        this.localStorageService.setShoppingCartVisible(true, 'FinanzenComponent');
    }

    ngOnInit() {
        /*this.warenkorbService.getWarenkorbContent().subscribe(response => {
          const len: number = response.records.length;
          this.localStorageService.setNumberOfShoppingCartItems(len);
        });*/
    }

    isTabMenuVisible(path: string) {
        return this.localStorageService.currentUserCanSeeTab(path);
    }

    isKontenrahmenBereichVisible(): boolean {
        return (
            this.isTabMenuVisible('/finanzen/kontenrahmen') ||
            this.isTabMenuVisible('/finanzen/fahrzeuge') ||
            this.isTabMenuVisible('/finanzen/honorar-tieraerzte')
        );
    }

    isKontenrahmenBereichActive(): boolean {
        return this.router.url.startsWith('/finanzen/kontenrahmen');
    }

    getKontenrahmenBereichLink(): string[] {
        if (this.isTabMenuVisible('/finanzen/kontenrahmen')) {
            return ['/finanzen/kontenrahmen'];
        }
        if (this.isTabMenuVisible('/finanzen/honorar-tieraerzte')) {
            return ['/finanzen/kontenrahmen/honorar-tieraerzte'];
        }
        return ['/finanzen/kontenrahmen/fahrzeuge'];
    }
}
